<template>
<div>
    <div class="row" v-if="!ready">
        <div class="col">
            <sau-loading></sau-loading>
        </div>
    </div>
    <div class="row pt-12" v-else>
        <div class="col-lg-3">
            <img src="/img/apiro-full-180.gif" />
        </div>
        <div class="col-lg-5">
            <h2 class="pt-12">Payment Unsuccessful</h2>
            <p>We were unable to process your payment. Please try again, or try a different method</p>
            <div v-if="message">
                <p>The payment gateway responded with this message:</p>
                <p>{{ message }}</p>
            </div>
            <p>If you’re still having problems, please contact us for help!</p>
            <a href="/support" class="btn btn-success">Contact Us</a>
        </div>
        <div class="col-lg-4 pt-4">
            <div class="sau-bx-shadow p-6">
                <div class="text-center px-4">
                    <h4 class="text-center sau-pm-reset">Invoice</h4>
                    <img src="/img/illustrations/invoice-unpaid.gif" alt="Invoice"/>
                    <p class="sau-pm-reset pb-2">Invoice Number: {{ invoiceComplete.id }}</p>
                    <a :href="`/billing/invoices/${invoiceComplete.id}`" class="sau-link-button sm d-block py-2">View Invoice</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    props: ['invoice-complete', 'message'],
    data(){
        return{
            ready: false,
        }
    },
    created() {
        this.ready = true;
    },
    methods:{
    }
}
</script>
